<template>
  <div>
    <a-table v-if="products" :columns="columns" :data-source="products">
      <a-button
        slot="actions"
        slot-scope="name, record"
        type="primary"
        block
        icon="tablet"
        @click="materials(record)"
      />
    </a-table>
  </div>
</template>

<script>
import { gocatalogProducts } from "@/api/gocase-api/products-api/products.api.js";
import { getCaseDevices } from "@/api/factory-api/case-device-api/caseDevice.api.js";

export default {
  data() {
    return {
      products: null,
      columns: [
        {
          title: "Id",
          dataIndex: "id",
          key: "id",
          width: 80,
        },
        {
          title: "Name",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "Sku",
          dataIndex: "sku",
          key: "sku",
          ellipsis: true,
        },
        {
          title: "Product Type Code",
          dataIndex: "product_type_code",
          key: "product_type_code",
          ellipsis: true,
        },
        {
          title: "Coverage",
          dataIndex: "devices_coverage",
          key: "devices_coverage",
          ellipsis: true,
        },
        {
          title: "",
          dataIndex: "actions",
          key: "actions",
          scopedSlots: { customRender: "actions" },
          ellipsis: true,
          width: 80,
        },
      ],
    };
  },
  computed: {
    identifier() {
      return this.$route.params.identifier;
    },
    coveragePrisma() {
      return this.$store.state.coveragePrisma;
    },
  },
  mounted() {
    const { identifier } = this;
    if (!identifier) this.$router.go(-1);

    getCaseDevices().then((res) => {
      if (!!res.materials) {
        const available = (m) => !res.materials || res.materials.includes(m);
        let devices = res.materials
          .filter((m) => m.indexOf("standard") !== -1)
          .map((m) => m.split("-")[1]);
        devices = devices
          .filter((item, pos) => devices.indexOf(item) == pos)
          .filter((d) => available(`standard-${d}`));

        gocatalogProducts({ identifier, countDevices: devices.length })
          .then(
            (products) =>
              (this.products = products
                .map((p) => this.product(p))
                .filter((p) => !!p))
          )
          .catch((err) => this.materials(null));
      }
    });
  },
  methods: {
    product(product) {
      const { coveragePrisma } = this;
      if (!coveragePrisma || !product) return false;
      const temp = coveragePrisma.find((p) => p.sku === product.sku);
      product.devices_coverage = "0%";
      if (!temp) return product;
      product.devices_coverage = `${temp.coverage}%`;
      return product;
    },
    materials(product) {
      const { identifier } = this;
      this.$router.push({
        name: "ListMaterials",
        params: { identifier, product },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
